module.exports = "/_next/static/images/BuildHighPerformance-1@2x-164c5452224ad32e34a9a3542b2b900c.webp";